/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_rg_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Random Number Generator & UUID Generator | Toolverse`)
};

const es_rg_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generador de Números Aleatorios y Generador de UUID | Toolverse`)
};

const de_rg_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zufallszahlengenerator & UUID-Generator | Toolverse`)
};

const nl_rg_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generator voor willekeurige nummers en UUID | Toolverse`)
};

const fr_rg_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Générateur de nombres aléatoires et générateur UUID | Toolverse`)
};

const it_rg_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generatore di Numeri Casuali e Generatore di UUID | Toolverse`)
};

const pt_br2_rg_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerador de Números Aleatórios e Gerador de UUID | Toolverse`)
};

const pt_rg_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerador de Números Aleatórios e Gerador de UUID | Toolverse`)
};

const ja_rg_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ランダム番号ジェネレータ & UUIDジェネレータ | Toolverse`)
};

const zh_rg_meta_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`随机数生成器与UUID生成器 | Toolverse`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const rg_meta_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.rg_meta_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("rg_meta_title", locale)
	if (locale === "en") return en_rg_meta_title(inputs)
	if (locale === "es") return es_rg_meta_title(inputs)
	if (locale === "de") return de_rg_meta_title(inputs)
	if (locale === "nl") return nl_rg_meta_title(inputs)
	if (locale === "fr") return fr_rg_meta_title(inputs)
	if (locale === "it") return it_rg_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_rg_meta_title(inputs)
	if (locale === "pt") return pt_rg_meta_title(inputs)
	if (locale === "ja") return ja_rg_meta_title(inputs)
	return zh_rg_meta_title(inputs)
};